<script setup lang="ts">
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button, type ButtonVariants } from '@/components/ui/button';

const { 
  title = 'Confirm Action',
  confirmText = 'Confirm', 
  cancelText = 'Cancel',
  variant = 'default',
  message,
  confirmDisabled = false,
  confirmDisabledTooltip,
} = defineProps<{
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  optionalText?: string;
  variant?: ButtonVariants['variant'];
  optionalVariant?: ButtonVariants['variant'];
  confirmDisabled?: boolean;
  confirmDisabledTooltip?: string;
}>();

const open = defineModel<boolean>('open');

const emit = defineEmits<{
  'confirm': [];
  'cancel': [];
  'optional': [];
}>();

function handleConfirm() {
  emit('confirm');
  open.value = false;
}

function handleCancel() {
  emit('cancel');
  open.value = false;
}

function handleOptional() {
  emit('optional');
  open.value = false;
}
</script>

<template>
  <Dialog :open="open" @update:open="(value) => open = value">
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{{ title }}</DialogTitle>
      </DialogHeader>
      <DialogDescription>
        {{ message }}
      </DialogDescription>
      <DialogFooter>
        <Button variant="outline" @click="handleCancel">
          {{ cancelText }}
        </Button>
        <Button v-if="optionalText" :variant="optionalVariant" @click="handleOptional">
          {{ optionalText }}
        </Button>
        <Button 
          :variant="variant"
          :disabled="confirmDisabled"
          :title="confirmDisabled ? confirmDisabledTooltip : undefined"
          @click="handleConfirm"
        >
          {{ confirmText }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template> 